import { Routes, Route } from "react-router-dom";
import { NoMatch } from "../pages/NoMatch";
import { ProtectedLayout } from "../layouts/ProtectedLayout";
import { PublicLayout } from "../layouts/PublicLayout";
import { useAuth } from "../hooks/useAuth";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { CorporateArtPortal } from "../pages/CorporateArtPortal";
import { Home } from "../pages/Home";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { Login } from "../pages/Login";
import { Answer } from "../pages/Answer";
import { DonationOrder } from "../pages/DonationOrder";
import { OrderDetails } from "../pages/OrderDetails";
import { LocationSurvey } from "../pages/LocationSurvey";
import { Signout } from "../pages/Signout";
import { Register } from "../pages/Register";
import { ArtWorkSelection } from "../pages/ArtWorkSelection";
import LoginWithAccess from "../pages/LoginWithAccess";
const Router = ({ application }) => {
    const { user, isAuthenticated, getUserDetailsNotAsync } = useAuth();
    const userData = getUserDetailsNotAsync();
    const path = "";
    const navigate = useNavigate();

    return (
        <Routes>
            <Route element={<PublicLayout />}>
                <Route path="/login-with-access" element={<LoginWithAccess />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/register" element={<Register />}></Route>
                <Route path="/answer" element={<Answer />}></Route>
                <Route path="/signout" element={<Signout />} />
                <Route path="*" element={<NoMatch />} />
            </Route>

            <Route path="/" element={<ProtectedLayout />}>
                <Route
                    path={path + "/"}
                    element={
                        <DashboardLayout>
                            <CorporateArtPortal />
                        </DashboardLayout>
                    }
                />
                <Route
                    path={path + "/artWorkSelection/:recordId"}
                    element={
                        <DashboardLayout>
                            <ArtWorkSelection />
                        </DashboardLayout>
                    }></Route>
                <Route
                    path={path + "/locationSurvey/:recordId"}
                    element={
                        <DashboardLayout>
                            <LocationSurvey />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/projectDetails/:recordId"
                    element={
                        <DashboardLayout>
                            <OrderDetails />
                        </DashboardLayout>
                    }></Route>
                <Route
                    path={path + "/donationProject/:recordId"}
                    element={
                        <DashboardLayout>
                            <DonationOrder />
                        </DashboardLayout>
                    }
                />
                <Route
                    path={path + "/donationOrder"}
                    element={
                        <DashboardLayout>
                            <DonationOrder />
                        </DashboardLayout>
                    }
                />
                <Route
                    path={path + "/favourite"}
                    element={
                        <DashboardLayout>
                            <Home enableFavourite={true} insideApplication={true} />
                        </DashboardLayout>
                    }
                />
                <Route path="*" element={<NoMatch />} />
            </Route>
        </Routes>
    );
};

export { Router };
